import ENV  from "./env";
var getPixelRatio = function(context) {
    var backingStore = context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio || 1;

    return (window.devicePixelRatio || 1) / backingStore;
};

function img_canvas(img, parent_node){
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d', { alpha: false });
    ctx.globalCompositeOperation = 'copy'
    // ctx.imageSmoothingEnabled = false;
    // let ratio = getPixelRatio(ctx);
    let ratio = Math.min(3, parseInt(window.devicePixelRatio));
    let w = Math.floor(img.offsetWidth);
    let h = Math.floor(img.offsetHeight);
    canvas.style.width = w + 'px';
    canvas.width = w * ratio;
    canvas.style.height = h + 'px';
    canvas.height = h * ratio;

    let attrs = img.attributes;
    if(attrs){
        for(let i = 0; i < attrs.length; i++){
            if(attrs[i].nodeName && /data-|class/.test(attrs[i].nodeName)){ //data- 为vue style设置的，不然scope样式不生效
                canvas.setAttribute(attrs[i].nodeName, attrs[i].nodeValue);
            }
        }
    }
    ctx.drawImage(img,0,0,w * ratio,h * ratio); //离屏绘制
    // parent_node.appendChild(canvas)
    if(parent_node){
        parent_node.insertBefore(canvas,img)
        parent_node.removeChild(img);
    }
    return canvas
}

export default {
    bind: function(el, binding, vNode) {
        let ENV = vNode.context.GL.ENV
        if(binding.value.on == true){
            return false
        }

        if(!binding.value.is_wrapper || binding.value.is_wrapper && binding.value.wrapper_text == false){
            el.className = `${el.className} nocopy`
        }

        el.__timer__ = null;
        const show_modal = () => {
            if(ENV.is_ios){
                document.body.className = document.body.className + ' nocopy';
            }
            vNode.context.$modal.show('dialog', {
                title: '无法保存图片',
                text:"创作者已开启版权保护",
                buttons: [
                    {
                      title: '关闭',
                      handler: () => {
                        if(ENV.is_ios){
                            document.body.className = document.body.className.replace('nocopy','')
                        }
                        vNode.context.$modal.hide('dialog');
                      },
                    }
                  ],
            });
        }
        //
        el.__contextmenu__ = (e) => {
            e.preventDefault();
            e.stopPropagation();
            show_modal();
        }
        el.__selectstart__ = (e) => {
            e.preventDefault();
            e.stopPropagation();
        }
        el.__copy__ = (e) => {
            e.preventDefault();
            e.stopPropagation();
        }
        el.__touchstart__ = (e) => {
            // if(ENV.is_android && !ENV.is_afd_client){
            //     e.preventDefault();
            //     return false;
            // }
            if(e.target.nodeName == 'CANVAS'){
                el.__starttime__ = +new Date()
                el.__timer__ = setTimeout(() => {
                    show_modal();
                }, 1500)
            }
            // e.preventDefault();
        }
        el.__touchmove__ = (e) => {
            if(el.__timer__){
                clearTimeout(el.__timer__)
                el.__timer__ = null
            }
        }
        el.__touchend__ = (e) => {
            el.__endtime__ = +new Date()
            if (el.__endtime__ - el.__starttime__ <= 1500) {
                clearTimeout(el.__timer__)
                el.__timer__ = null
            }
        }
        if(binding.value.is_wrapper && binding.value.wrapper_pic == false){
            el.querySelectorAll('img').forEach(img_vode => {
                img_vode.addEventListener('load', () =>{
                    let p = img_vode.parentNode;
                    if(!ENV.is_ios){
                        img_vode.target = img_canvas(img_vode, p)
                    }else{
                        img_vode.target = img_vode;
                    }
                    img_vode.target.addEventListener('contextmenu', el.__contextmenu__)
                    img_vode.target.addEventListener('touchmove', el.__touchmove__)
                    img_vode.target.addEventListener('touchstart', el.__touchstart__)
                    img_vode.target.addEventListener('touchend', el.__touchend__)
                })
            });
            return false;
        }
        if(el.nodeName == 'IMG'){
            el.addEventListener('load', () =>{
                let p = el.parentNode;
                if(!ENV.is_ios){
                    el.target = img_canvas(el, p)
                }else{
                    el.target = el
                }
                el.target.addEventListener('contextmenu', el.__contextmenu__)
                el.target.addEventListener('touchmove', el.__touchmove__)
                el.target.addEventListener('touchstart', el.__touchstart__)
                el.target.addEventListener('touchend', el.__touchend__)
                // p.appendChild(el.canvas)
                // p.removeChild(el);

            })
            return false;
        }
        // el.addEventListener('touchstart', el.__touchstart__)
        el.addEventListener('selectstart', el.__selectstart__)
        el.addEventListener('copy', el.__copy__)
        // el.className = `${el.className} nocopy`
        // el.className = `${el.className} nocopy ${ENV.is_wechat ? 'nocopy-img' : ''}`
        // el.className = `${el.className} nocopy ${ENV.is_android ? 'nocopy-img' : ''}`

    },

    unbind: function(el, binding) {
        if(binding.value.on == true){
            return false
        }
        // Remove Event Listeners
        el.removeEventListener('contextmenu', el.__contextmenu__)
        el.removeEventListener('touchstart', el.__touchstart__)
        el.removeEventListener('touchmove', el.__touchmove__)
        el.removeEventListener('touchend', el.__touchend__)
        el.removeEventListener('selectstart', el.__selectstart__)
        el.removeEventListener('copy', el.__copy__)
        if(el.target){
            el.target.removeEventListener('contextmenu', el.__contextmenu__)
            el.target.removeEventListener('touchmove', el.__touchmove__)
            el.target.removeEventListener('touchend', el.__touchend__)
            el.target.removeEventListener('touchstart', el.__touchstart__)
            el.target = null
        }
        el.className = el.className.replace('nocopy','').replace('nocopy-img','')
        document.body.className = document.body.className.replace('nocopy','')

    }
}
